import { c as _c } from "react/compiler-runtime";
import { DesktopSkeleton } from './Desktop/DesktopSkeleton';
import { MobileSkeleton } from './Mobile/MobileSkeleton';
export function ProductCardSkeleton(t0) {
  const $ = _c(3);
  const {
    isDriverGroupImprovementsPhase2ExperimentEnabled: t1
  } = t0;
  const isDriverGroupImprovementsPhase2ExperimentEnabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DesktopSkeleton />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== isDriverGroupImprovementsPhase2ExperimentEnabled) {
    t3 = <div data-testid="skeleton-card">{t2}<MobileSkeleton isDriverGroupImprovementsPhase2ExperimentEnabled={isDriverGroupImprovementsPhase2ExperimentEnabled} /></div>;
    $[1] = isDriverGroupImprovementsPhase2ExperimentEnabled;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}